/* eslint-disable no-undef */
/* eslint-disable no-invalid-this */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ButtonGroup from 'zignal-landscape/lib/ButtonGroup';
import Button from 'zignal-landscape/lib/Button';
import Link from 'zignal-landscape/lib/Link';
import ConfirmationModal from 'zignal-landscape/lib/ConfirmationModal';
import ModalHeader from 'zignal-landscape/lib/ModalHeader';
import Loading from 'zignal-landscape/lib/Loading';
import themeable from 'zignal-landscape/lib/themeable';
import ThemeProvider from 'zignal-landscape/lib/ThemeProvider';
import noop from 'lodash/noop';
import { Light } from 'themes';

import Add1Icon from 'zignal-landscape/lib/Icon/Add1Icon';
import DuplicateIcon from 'zignal-landscape/lib/Icon/DuplicateIcon';
import EditIcon from 'zignal-landscape/lib/Icon/EditIcon';


import SideBarNav from '../SideBarNav';

let geoHelperInstance;
const getGeoHelper = () => {
  if (!geoHelperInstance) {
    geoHelperInstance = new window.Util.GeoHelper();
  }
  return geoHelperInstance;
};

const IconMapping = {
  add: Add1Icon,
  duplicate: DuplicateIcon,
  edit: EditIcon,
  default: null
};

const TitleMapping = {
  add: 'Create New Smart Filter',
  duplicate: 'Duplicate Smart Filter',
  edit: 'Edit Smart Filter',
  default: null
};

const confirmationModalTitleMapping = {
  confirm: 'Your changes will not be saved',
  error: 'Smart Filter Error'
};

const confirmationModalTextMapping = {
  confirm: 'Your changes to your Smart Filter will not be saved, do you want to continue?',
  error: 'There was an error saving this Smart Filter. Please try again'
};


class SmartFilterPane extends Component {
  state={
    showConfirmation: false,
    hideConfimationCancelButton: false,
    showSideNavBar: true,
    showHeaderAndButtons: false,
    confirmationModalTitle: confirmationModalTitleMapping.confirm,
    confirmationModalText: confirmationModalTextMapping.confirm
  };
  componentDidMount(){
    this._isMounted = true;
    this.initSmartFilter();
  }
  componentWillUnmount(){
    if(this.smartFilter){
      this.smartFilter.remove();
    }
  }
  onCancel = (_e, smartFilter = this.smartFilter) => {
    const {onCancel} = this.props;
    if(smartFilter.isPristine){
      this.setState({showConfirmation : false, showSideNavBar : false});
      onCancel();
    }
    else{
      // eslint-disable-next-line no-invalid-this
      this.setState({
        showConfirmation: true,
        confirmationModalTitle: confirmationModalTitleMapping.confirm,
        confirmationModalText: confirmationModalTextMapping.confirm,
        hideConfimationCancelButton : false,
      });
    }
  };
  onConfirm = () =>{
    const {hideConfimationCancelButton} = this.state;
    const { onCancel } = this.props;
    //If the modal error was fired
    if(hideConfimationCancelButton){
      this.setState({showConfirmation : false, showSideNavBar : true});
    }
    else{
      this.setState({showConfirmation : false, showSideNavBar : false});
      onCancel();
    }
  };
  onSmartFilterSave = (_e, smartFilter = this.smartFilter) => {
    const {mode} = this.props;
    const {onCancel} = this;
    // Validate that the model it is valid (Bacbone)
    if(smartFilter.validateName()){
      this.saveSmartFilter();
    }
    else if(smartFilter.validateName() && mode === 'duplicate'){
      this.saveSmartFilter();
    }
    else if (smartFilter.isPristine){
      onCancel();
    }
  };
  saveSmartFilter =() =>{
    const {onSave, model, mode, saveAndApply} = this.props;
    model.set('candidates', []);
    getGeoHelper().fixGeoReferenceAtrrs(model.attributes);
    model.save(null, {success: (data)=>{
      this.setState({showConfirmation : false, showSideNavBar : false});
      onSave(data, mode, model, saveAndApply);
    },error: (res, err)=>{
      let errorMessage;
      try {
        const messages = JSON.parse(err.responseText).messages;
        errorMessage = messages.join('<br>');
      } catch (e) {
        errorMessage = confirmationModalTextMapping.error;
      }
      this.setState({
        showConfirmation : true,
        showSideNavBar : true,
        confirmationModalTitle: confirmationModalTitleMapping.error,
        confirmationModalText: errorMessage,
        hideConfimationCancelButton: true,
        saveError: true
      });
    }});
  };
  _isMounted = false;
  smartFilter = null;
  initSmartFilter = (props = this.props) =>{
    const { model, filterName, onInit } = props;
    const el = this.smartFilterPaneContainerContent;
    if (el) {
      // https://developer.chrome.com/blog/mutation-events-deprecation
      const observer = new MutationObserver((mutationList) => (
        mutationList.filter((m) => m.type === 'childList').forEach((m) => {
          m.addedNodes.forEach(this.detectSmartFilterRendered);
        }))
      );
      observer.observe(el ,{childList: true, subtree: true});
      this.setState({observer});
    }
    // eslint-disable-next-line no-undef
    // TODO: Smartfilter Backbone implementation will be removed soon
    this.smartFilter =  new Views.NewsroomSidebar({
      containerType: 'ReactPane',
      nameOrTitle: filterName || model.get('name'),
      model,
      type: 'DashboardFilter',
      container: el,
      isMediaScoreEnabled: true,
      select2Options: {
        dropdownCssClass: 'modal-select2-dropdown',
        maskCssClass: 'modal-select2-dropdown-mask'
      }
    });

    onInit();
  };
  // Detect if the smart filter was render and shows header and button group
  detectSmartFilterRendered = () => {
    const el = this.smartFilterPaneContainerContent;
    // disconnect MutationObserver
    if (el && this.state.observer && this.state.observer.disconnect) {
      this.state.observer.disconnect();
      this.setState({observer: null});
    }
    if (this._isMounted && this.state.showHeaderAndButtons === false) {
      this.setState({showHeaderAndButtons: true});
    }
  };
  handleCancel = () => {
    this.setState({showConfirmation : false});
  };
  render() {
    const {styles, content, mode, saveAndApply} = this.props;
    const {onCancel, handleCancel, onSmartFilterSave, onConfirm} = this;
    const {
      showConfirmation,
      showSideNavBar,
      showHeaderAndButtons,
      confirmationModalTitle,
      confirmationModalText,
      hideConfimationCancelButton,
    } = this.state;
    const Icon = IconMapping[mode];
    const Title = TitleMapping[mode];
    const saveAndApplyText = saveAndApply ? 'Save and Apply' : 'Save';
    return (
      <ThemeProvider theme={Light}>
        <div>
          <ConfirmationModal
            title={confirmationModalTitle}
            isOpen={showConfirmation}
            confirmStyle="alert"
            confirmText="Continue"
            hideCancel={hideConfimationCancelButton}
            onCancel={handleCancel}
            size="small"
            onConfirm={onConfirm}
          >
            {confirmationModalText}
          </ConfirmationModal>
          <SideBarNav
            onEscapePress={onCancel}
            isOpen={showSideNavBar}
          >
            <div className={styles.container}>
              <div className={styles.SmartFilterPaneContainer}>
                {showHeaderAndButtons?<div className={styles.SmartFilterPaneContainerHeader}>
                  <ModalHeader onClose={onCancel}>
                    <div className={styles.SmartFilterPaneContainerIcon}>
                      <Icon />
                      <div className={styles.SmartFilterPaneContainerTitle}>
                        {Title}
                      </div>
                    </div>
                  </ModalHeader>
                </div>: null}
                <div
                  // eslint-disable-next-line max-len
                  ref={(smartFilterPaneContainerContent) => {
                    // eslint-disable-next-line no-return-assign
                    return this.smartFilterPaneContainerContent = smartFilterPaneContainerContent;
                  }}
                  className={styles.SmartFilterPaneContainerContent}
                >
                  {content}
                  <div className={styles.SmartFilterPaneLoading}>
                    <Loading blockUi={false} />
                  </div>
                </div>
              </div>
              {showHeaderAndButtons?<div className={styles.buttonGroupContainer}>
                <ButtonGroup>
                  <Link linkType="cancel" onClick={onCancel}>Cancel</Link>
                  <Button
                    data-cy="SmartFilterPane_SaveButton"
                    onClick={onSmartFilterSave}
                    buttonStyle="secondary"
                  >
                    {saveAndApplyText}
                  </Button>
                </ButtonGroup>
              </div>: null}
            </div>
          </SideBarNav>
        </div>
      </ThemeProvider>
    );
  }
}

SmartFilterPane.propTypes = {
  styles: PropTypes.object,
  onSave: PropTypes.func,
  onInit: PropTypes.func,
  content: PropTypes.object,
  model: PropTypes.object,
  mode: PropTypes.string,
  filterName: PropTypes.string,
  saveAndApply: PropTypes.bool,
  onCancel: PropTypes.func,
};

SmartFilterPane.defaultProps = {
  onInit: noop,
  onCancel: noop,
  content: {},
  mode: 'edit',
  filterName: '',
  saveAndApply: false,
  model: {}
};

export default themeable(SmartFilterPane);
